import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Premium Hero Section */}
      <section className="relative bg-gradient-to-br from-[#00c2ab] to-[#009688] text-white pt-24 pb-48 overflow-hidden">
        {/* Abstract Background Elements */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-80 h-80 rounded-full bg-white opacity-10 blur-3xl mix-blend-overlay"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-72 h-72 rounded-full bg-white opacity-10 blur-2xl mix-blend-overlay"></div>
        
        <div className="container mx-auto px-4 text-center relative z-10 animate-fadeIn">
          <div className="inline-block px-4 py-1 bg-white/20 backdrop-blur-md rounded-full text-sm font-semibold tracking-wider mb-6 border border-white/30">
            LEGAL AGREEMENT
          </div>
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 tracking-tight drop-shadow-md">Terms of Service</h1>
          <p className="text-xl md:text-2xl max-w-2xl mx-auto text-teal-50 font-medium">
            Last updated: December 17, 2025
          </p>
        </div>
      </section>

      {/* Terms Content - Floating Document */}
      <section className="relative z-20 -mt-28 mb-24 px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto bg-white rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-8 md:p-16 border border-gray-100 animate-fadeIn" style={{ animationDelay: '0.1s' }}>
            <div className="prose max-w-none text-gray-600 leading-relaxed">
              
              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">1.</span> Acceptance of Terms
                </h2>
                <p className="text-lg">
                  By accessing and using Teztech ("the Platform"), you accept and agree to be bound by the 
                  terms and provision of this agreement. If you do not agree to these Terms of Service, 
                  please do not use the Platform.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">2.</span> User Accounts
                </h2>
                <p className="text-lg mb-4">
                  To access certain features of the Platform, you must register for an account. When you 
                  register, you agree to:
                </p>
                <ul className="space-y-3 text-lg pl-2">
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Provide accurate, current, and complete information</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Maintain and promptly update your account information</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Maintain the security of your password and account</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Accept responsibility for all activities under your account</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Notify us immediately of any unauthorized use of your account</span>
                  </li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">3.</span> User Conduct
                </h2>
                <p className="text-lg mb-4">You agree not to:</p>
                <ul className="space-y-3 text-lg pl-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Post false, inaccurate, misleading, or fraudulent information</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Impersonate any person or entity</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Harass, abuse, or harm another person or entity</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Violate any applicable laws or regulations</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Upload or transmit viruses or malicious code</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Spam or send unsolicited messages to other users</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Collect or store personal data about other users</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Interfere with or disrupt the Platform or servers</span>
                  </li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">4.</span> Job Postings and Applications
                </h2>
                
                <div className="bg-gray-50 p-6 rounded-2xl mb-6 border border-gray-100">
                  <h3 className="text-xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#00c2ab] pl-3">For Employers:</h3>
                  <ul className="space-y-3 text-lg pl-2">
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>Job postings must be accurate and represent genuine employment opportunities</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>You must have the authority to post jobs on behalf of your organization</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>You agree not to discriminate in your hiring practices</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>You will handle applicant data in compliance with privacy laws</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                  <h3 className="text-xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#00c2ab] pl-3">For Job Seekers:</h3>
                  <ul className="space-y-3 text-lg pl-2">
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>Your profile and resume information must be accurate and truthful</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>You grant employers permission to view your profile and contact you</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                      <span>You are responsible for all communications with employers</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">5.</span> Intellectual Property
                </h2>
                <p className="text-lg">
                  All content on the Platform, including text, graphics, logos, images, and software, is 
                  the property of Teztech or its content suppliers and is protected by intellectual property 
                  laws. You may not reproduce, distribute, or create derivative works without our express 
                  written permission.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">6.</span> Payment and Refunds
                </h2>
                <p className="text-lg mb-4">For paid services:</p>
                <ul className="space-y-3 text-lg pl-2">
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>All fees are non-refundable unless otherwise stated</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Prices are subject to change with notice</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>You authorize us to charge your payment method for all fees</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="mt-2 w-2 h-2 rounded-full bg-[#00c2ab] shrink-0"></span>
                    <span>Failed payments may result in service suspension</span>
                  </li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">7.</span> Privacy
                </h2>
                <p className="text-lg">
                  Your use of the Platform is also governed by our Privacy Policy. Please review our 
                  <Link to="/privacy" className="text-[#00c2ab] hover:text-[#009688] font-bold mx-1 transition-colors">Privacy Policy</Link> 
                  to understand our practices.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">8.</span> Disclaimer of Warranties
                </h2>
                <div className="bg-orange-50 border border-orange-100 p-6 rounded-2xl">
                  <p className="text-lg text-orange-900 font-medium">
                    THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. 
                    WE DO NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF 
                    VIRUSES OR OTHER HARMFUL COMPONENTS.
                  </p>
                </div>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">9.</span> Limitation of Liability
                </h2>
                <div className="bg-orange-50 border border-orange-100 p-6 rounded-2xl">
                  <p className="text-lg text-orange-900 font-medium">
                    TO THE MAXIMUM EXTENT PERMITTED BY LAW, TEZTECH SHALL NOT BE LIABLE FOR ANY INDIRECT, 
                    INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR 
                    REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY.
                  </p>
                </div>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">10.</span> Termination
                </h2>
                <p className="text-lg">
                  We reserve the right to suspend or terminate your account at any time, with or without 
                  notice, for any reason, including violation of these Terms of Service.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">11.</span> Changes to Terms
                </h2>
                <p className="text-lg">
                  We reserve the right to modify these Terms of Service at any time. We will notify users 
                  of any material changes. Your continued use of the Platform after changes constitutes 
                  acceptance of the modified terms.
                </p>
              </div>

              <div className="mb-16">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-[#00c2ab]">12.</span> Governing Law
                </h2>
                <p className="text-lg">
                  These Terms shall be governed by and construed in accordance with the laws of India, 
                  without regard to its conflict of law provisions.
                </p>
              </div>

              {/* Premium Contact Card */}
              <div className="bg-gradient-to-br from-teal-50 to-white p-8 md:p-10 rounded-3xl border border-teal-100 shadow-sm relative overflow-hidden">
                <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 rounded-full bg-[#00c2ab] opacity-5 blur-2xl"></div>
                
                <h2 className="text-3xl font-extrabold text-gray-900 mb-4 relative z-10">13. Contact Us</h2>
                <p className="text-lg mb-8 relative z-10">
                  If you have any questions about these Terms of Service, please contact us:
                </p>
                
                <div className="grid md:grid-cols-2 gap-6 relative z-10">
                  <div className="flex flex-col gap-2">
                    <span className="text-sm font-bold text-teal-600 uppercase tracking-wider">Email</span>
                    <a href="mailto:info@teztecch.com" className="text-xl font-bold text-gray-900 hover:text-[#00c2ab] transition-colors">
                      info@teztecch.com
                    </a>
                  </div>
                  <div className="flex flex-col gap-2">
                    <span className="text-sm font-bold text-teal-600 uppercase tracking-wider">Phone</span>
                    <a href="tel:+918956610799" className="text-xl font-bold text-gray-900 hover:text-[#00c2ab] transition-colors">
                      +91 89566 10799
                    </a>
                  </div>
                  <div className="md:col-span-2 flex flex-col gap-2 mt-4 pt-6 border-t border-teal-100/50">
                    <span className="text-sm font-bold text-teal-600 uppercase tracking-wider">Address</span>
                    <p className="text-lg text-gray-900">
                      Plot 1/A/K, Beside Gajanan Primary School,<br/>
                      Ayodhya Nagar, Nagpur – 440 024
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
